import React from 'react'
import { gtmEvent } from 'lib/gtm'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import ExternalLinkButton from 'components/external-link-button'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  buttonBox: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    margin: '16px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  viewButton: {
    marginRight: '16px',
  },
}))

export const GetADMCertifiedTitle = ({
  completedAdmCourseCount,
  totalAdmCourseCount,
}) => (
  <Box mb={2}>
    <Divider style={{ marginBottom: '20px' }} />
    <Typography variant="subtitle1">
      {completedAdmCourseCount}/{totalAdmCourseCount} courses complete
    </Typography>
  </Box>
)

export default ({ isComplete }) => {
  const classes = useStyles()
  const viewADMCertificateLink =
    'https://vt.lightspeedvt.com/share/redirect.cfm?signInURL=https://webservices.lightspeedvt.net/SAML/lsvt/login.aspx?h=pga.onelogin.com&dest=https://vt.lightspeedvt.com/reports/certification/'
  const goToTrainingLink =
    'https://vt.lightspeedvt.com/share/redirect.cfm?signInURL=https://webservices.lightspeedvt.net/SAML/lsvt/login.aspx?h=pga.onelogin.com&dest=https://vt.lightspeedvt.com/trainingCenter/'
  return (
    <Box display="flex" flexDirection="column">
      <Typography>
        The American Development Model was designed by sports scientists to help
        support a lifetime affinity to sports, and to develop athletes to their
        greatest potential. Get ADM Certified today, and unlock the full
        marketing potential of your very own PGA Coach Profile.
      </Typography>
      <Box className={classes.buttonBox}>
        {isComplete && (
          <ExternalLinkButton
            href={viewADMCertificateLink}
            variant="outlined"
            color="primary"
            fullWidth
            className={classes.viewButton}
            style={{ marginTop: '25px' }}
            onClick={() => {
              gtmEvent({
                event: 'onboarding-click',
                onboardingCategory: 'onboarding-dashboard',
                onboardingLabel: 'get-adm-certified',
                onboardingAction: 'click-view-adm-certificate',
              })
            }}
          >
            View ADM Certificate
          </ExternalLinkButton>
        )}
        <ExternalLinkButton
          href={goToTrainingLink}
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginTop: '25px' }}
          onClick={() => {
            gtmEvent({
              event: 'onboarding-click',
              onboardingCategory: 'onboarding-dashboard',
              onboardingLabel: 'get-adm-certified',
              onboardingAction: 'click-get-started',
            })
          }}
        >
          Go to Training
        </ExternalLinkButton>
      </Box>
    </Box>
  )
}
